import { GlobalSearchGroup, GlobalSearchItem, GlobalSearchType } from '../types/globalSearchTypes';

export const GLOBAL_SEARCH_TYPES = {
  PLAYER_LOGIN: 1,
  PLAYER_ID: 2,
  EXTERNAL_PLAYER_ID: 3,
};

export const MIN_SEARCH_INPUT_LENGTH = 3;

export const typeToLabelMap: Record<number, string> = {
  [GLOBAL_SEARCH_TYPES.PLAYER_LOGIN]: 'Player Login',
  [GLOBAL_SEARCH_TYPES.PLAYER_ID]: 'Player ID',
  [GLOBAL_SEARCH_TYPES.EXTERNAL_PLAYER_ID]: 'External Player ID',
};

export const groupGlobalSearchItems = (items: GlobalSearchItem[]): GlobalSearchGroup[] => {
  const groups = new Map<GlobalSearchType, GlobalSearchItem[]>();

  items.forEach((item) => {
    if (!groups.has(item.Type)) {
      groups.set(item.Type, []);
    }

    groups.get(item.Type)?.push(item);
  });

  return Array.from(groups.entries());
};

export const isPlayerRoute = (type: GlobalSearchType): boolean => type === GLOBAL_SEARCH_TYPES.PLAYER_LOGIN
|| type === GLOBAL_SEARCH_TYPES.PLAYER_ID
|| type === GLOBAL_SEARCH_TYPES.EXTERNAL_PLAYER_ID;
